import api from './api';

export interface JobInvitation {
  id?: number;
  employer_id: number;
  candidate_id: number;
  job_id?: number | null;
  cv_id?: number | null;
  invitation_letter_id?: number | null;
  status: 'pending' | 'accepted' | 'rejected' | 'expired';
  expires_at?: string | null;
  sent_at?: string;
  responded_at?: string | null;
  // Extended fields from JOIN
  employer_name?: string;
  employer_company?: string;
  candidate_name?: string;
  job_title?: string;
  letter_title?: string;
  letter_content?: string;
}

export const jobInvitationService = {
  // Send an invitation (employer)
  async send(data: {
    candidate_id: number;
    job_id?: number;
    cv_id?: number;
    invitation_letter_id?: number;
    expires_at?: string;
  }): Promise<JobInvitation> {
    const response = await api.post('/job-invitations', data);
    return response.data.data;
  },

  // Get invitations received (employee)
  async getReceived(): Promise<JobInvitation[]> {
    const response = await api.get('/job-invitations/received');
    return response.data.data;
  },

  // Get invitations sent (employer)
  async getSent(): Promise<JobInvitation[]> {
    const response = await api.get('/job-invitations/sent');
    return response.data.data;
  },

  // Update invitation status (employee)
  async updateStatus(id: number, status: 'pending' | 'accepted' | 'rejected' | 'expired'): Promise<void> {
    await api.patch(`/job-invitations/${id}/status`, { status });
  },

  // Delete invitation (employer)
  async delete(id: number): Promise<void> {
    await api.delete(`/job-invitations/${id}`);
  }
};

